import Products from './Products';
import ProductDetail from './ProductDetail';

export {
    Products,
    ProductDetail,
};
